import React, { useEffect } from "react";
import PropTypes from "prop-types";
import gql from "graphql-tag";
import get from "lodash/get";
import { useQuery } from "@apollo/react-hooks";
import { withRouter } from "react-router-dom";

import Context from "shared/util/Context";
import { voucherCheck } from "shared/components/VoucherModal/helpers";
import useBodyClassName from "routers/shared/hooks/useBodyClassName";
import useStats from "routers/shared/hooks/useStats";
import {
	getPageName,
	getBodyClassList,
} from "routers/shared/util/helpers";

import UniversalHead from "routers/shared/components/UniversalHead";
import TrackingCenter from "routers/shared/components/TrackingCenter";
import HeaderBanner from "routers/Desktop/HeaderBanner";
import NavBar from "routers/Desktop/NavBar";
import AuthedRoutes from "routers/Desktop/AuthedRoutes";
import UnauthedRoutes from "routers/Desktop/UnauthedRoutes";
import Footer from "routers/Desktop/Footer";
import LazyStaffbar from "routers/shared/components/LazyStaffbar";

const QUERY = gql`
	${HeaderBanner.fragments.bannerUserData}
	${HeaderBanner.fragments.bannerSessionData}

	query userDataForPage($userid: String!) {
		user(id: $userid) {
			id
			isIncognito
			hasPhotos
			boostTokenCount
			...BannerUserData
		}
		session {
			...BannerSessionData
		}
	}
`;

const Page = ({ location }) => {
	const userid = Context.get("userid");
	const { data } = useQuery(QUERY, {
		variables: {
			userid,
		},
		skip: !userid,
	});

	// Get necessary data for rendering.
	const adFree = Context.get("adFree");
	const isStaff = !!Context.get("isStaff");
	const user = get(data, "user");
	const hasPhotos = !!get(user, "hasPhotos");
	const hasBoostTokens = !!get(user, "boostTokenCount");
	const isIncognito = !!get(user, "isIncognito");
	const isLoggedIn = !!userid;
	const isSpa = true;
	const classListParams = {
		adFree,
		hasPhotos,
		hasBoostTokens,
		isLoggedIn,
		isSpa,
		isIncognito,
	};
	const classList = [
		...getBodyClassList(classListParams),
		getPageName(location),
	];
	useBodyClassName(...classList);

	// Fire some stats.
	useStats({
		isLoggedIn,
		isStaff,
		location,
	});

	// check if voucher modal should appear
	useEffect(() => {
		voucherCheck();
	}, []);

	return (
		<>
			<UniversalHead location={location} />
			<TrackingCenter location={location} />
			<HeaderBanner location={location} {...data} />
			<main id="page">
				<NavBar userid={userid} location={location} />
				<div id="main_content" className="page-section">
					{isLoggedIn
						? <AuthedRoutes userid={userid} location={location} />
						: <UnauthedRoutes userid={userid} location={location} />}
				</div>
				<Footer location={location} />
			</main>
			<LazyStaffbar isStaff={isStaff} />
		</>
	);
};

Page.propTypes = {
	location: PropTypes.object.isRequired,
};

export default withRouter(Page);



// WEBPACK FOOTER //
// ./src/routers/Desktop/Page.jsx